import React, { useState } from 'react';
import PropTypes from 'prop-types';

import LeaseTerms from 'components/lease_structure/form/lease_terms';
import LeaseStructureCreateModal from 'bundles/apex/deals/form/fields/lease_structure/create_modal';
import { buildLeaseStructure } from './helpers';
import { getTransactionSideOptionLabels } from 'bundles/apex/deals/helpers/labels';

export default function DealLeaseTerms({
  changeDeal,
  deal,
  enableOperatingExpenses,
  readOnly,
  onChange,
  onIsRentCalculatedChange
}) {
  const [showModal, setShowModal] = useState(false);

  const transactionSideOptions = getTransactionSideOptionLabels(deal.dealType);

  function handleLeaseStructureChange(changes) {
    if (changes.hasOwnProperty('includeOperatingExpenses')) {
      changeDeal({ includeOperatingExpenses: changes.includeOperatingExpenses });
    }

    if (changes.hasOwnProperty('isRentCalculated')) {
      onIsRentCalculatedChange(changes.isRentCalculated);
    }
  }

  return <React.Fragment>
    <LeaseTerms
      className="deal-lease-terms"
      enableOperatingExpenses={enableOperatingExpenses}
      leaseStructure={buildLeaseStructure(deal)}
      readOnly={readOnly}
      showHeader={false}
      showTransactionSides={!!deal.hasTransactionSides}
      transactionSideOptions={transactionSideOptions}
      onChange={onChange}
      onLeaseStructureChange={handleLeaseStructureChange}
      onShowRentEscalationModal={() => setShowModal(true)}
    />

    <LeaseStructureCreateModal
      show={showModal}
      onCancel={() => setShowModal(false)}
      onCreate={() => setShowModal(false)}
    />
  </React.Fragment>;
}

DealLeaseTerms.propTypes = {
  changeDeal: PropTypes.func.isRequired,
  deal: PropTypes.object.isRequired,
  enableOperatingExpenses: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onIsRentCalculatedChange: PropTypes.func.isRequired,
};
